import { gql } from '@apollo/client';
const GET_SPECIFICATION_AND_FOLDER_CONVERSATIONS = gql `
  query GetSpecificationAndFolderConversations {
    getSpecificationAndFolderConversations {
      id
      title
      pageUrl
      type
      members {
        edges {
          node {
            id
            user {
              id
              username
              email
              avatar
            }
          }
        }
      }
      messages {
        edges {
          node {
            id
            text
            createdDate
            image
            sender {
              id
              username
              email
            }
            sendByMe
          }
        }
      }
    }
  }
`;
export default GET_SPECIFICATION_AND_FOLDER_CONVERSATIONS;
